import infoGraphy from '../assets/infoGraphy.jpeg'

export default function JourneyMap() {
    return (
        <div className='journeyMap-container'>
            <img src={infoGraphy} alt='' />
        </div>
    )
}
